import { request } from '../utils';

export default baseUrl => ( ctx, payload = {}) => {
  return request( ctx, `${baseUrl}/remove/ids`, payload, false, 'delete' );
};
